import type { NodeStatus } from '../api/types';
import { formatGb } from '../format';
import { Meter } from './ui';

/** これ以上使っていたら、カードに文章でも知らせる（Meter の赤と同じ） */
const DISK_DANGER_RATIO = 0.9;

export function NodeDisks({ disks }: { disks: NonNullable<NodeStatus['disks']> }) {
  const full = disks.some((disk) => disk.totalGb > 0 && disk.usedGb / disk.totalGb >= DISK_DANGER_RATIO);
  return (
    <>
      {disks.map((disk) => (
        <Meter
          key={disk.name ?? disk.kind}
          label={disk.kind === 'pool' ? `ディスク（${disk.name}）` : 'ディスク'}
          value={disk.usedGb}
          max={disk.totalGb}
          detail={`${formatGb(disk.usedGb * 1024)} / ${formatGb(disk.totalGb * 1024)}`}
        />
      ))}
      {full && (
        <p className="alert danger">
          ディスクの空きが少なくなっています。満杯になると Proxmox
          の管理機能が止まり、このノードのサーバーにつながらなくなります。毎晩のバックアップ（/var/lib/vz/dump）が溜まっていないか確認してください。
        </p>
      )}
    </>
  );
}
